import React, {useEffect} from "react";

import "./MenuAlertas.scss";

import SectionTitle from "@components/LeftMenu/SectionTitle";
import {useDiariosOficiais} from "@context/DiariosOficiais";
import {useDiariosOficiaisFiltro} from "@context/DiarioOficialFiltro";

function MenuAlertas() {
  const {reloadDiarios} = useDiariosOficiais();
  const {filtro} = useDiariosOficiaisFiltro();

  useEffect(() => {
    reloadDiarios(filtro);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtro.poder, filtro.esfera]);

  return <React.Fragment></React.Fragment>;
}

export default MenuAlertas;
